// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d2cf0805","239":"8132ea37","455":"8e0ff2d6"}[chunkId] + ".chunk.js";
};